import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { setPendingDestination } from './Functions/PendingDestination';

const RouteGuard = ({ children, redirectTo }) => {
  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  const location = useLocation();

  console.log('authstatus in route guard:', authStatus);

  if (authStatus === 'configuring') {
    return <div>Loading...</div>;
  }

  if (authStatus !== 'authenticated') {
    setPendingDestination(location.pathname + location.search);
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default RouteGuard;